var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import NcodeFetcher from "./NcodeFetcher";
import { isSamePage, makeNPageIdStr } from "../../common/util";
let _fi = null;
export default class NcodeFetcherPool {
    constructor() {
        this._codeData = [];
        this.findCodeData = (pageInfo) => {
            const found = this._codeData.find(item => isSamePage(pageInfo, item.pageInfo));
            if (!found)
                return undefined;
            if (found.glyphData.length < 16) {
                console.error("something wrong!");
                return undefined;
            }
            return found;
        };
        this.getNcodeData = (sobp, assignedUrl) => __awaiter(this, void 0, void 0, function* () {
            const alreadyDownloaded = this.findCodeData(sobp);
            if (alreadyDownloaded) {
                console.log(`[fetch already] NcodeFetcherPool, already loaded: ${makeNPageIdStr(sobp)}`);
                return alreadyDownloaded;
            }
            // const fetcher = new NcodeFetcher(pageInfo);
            const fetcher = new NcodeFetcher();
            const ncodeSurfaceDesc = yield fetcher.getNcodeData(sobp, assignedUrl);
            if (ncodeSurfaceDesc.glyphData.length > 16) {
                this._codeData.push(ncodeSurfaceDesc);
            }
            return ncodeSurfaceDesc;
        });
        if (_fi)
            return _fi;
    }
    static getInstance() {
        if (_fi)
            return _fi;
        _fi = new NcodeFetcherPool();
        return _fi;
    }
}
//# sourceMappingURL=NcodeFetcherPool.js.map